export function getHeaderLogoMaxWidth(screenSize) {
  if (screenSize === "small") {
    return 88;
  }

  if (screenSize === "medium") {
    return 128;
  }

  return 220;
}
